import React from "react";

const NoPage = () => {
  return <div>NoPage Page Not Found</div>;
};

export default NoPage;
